// repository.ts
import { getApiClient } from '@mit/aws-vue';
import { DirectDepositApi, PaymentPreferences, PaymentPreferencesUpdate, Init, BankInfoResponse } from '@/api/DirectDepositApi';
import { useDuoAuthStore } from '@/stores/duoAuthStore';

const directDepositRepository = getApiClient(DirectDepositApi, 'direct-deposit@v1');

// Payment preferences API methods
export const getPaymentPreferences = async (): Promise<PaymentPreferences> => {
    const response = await directDepositRepository.paymentPreferences.paymentPreferencesList();
    return response.data;
};

export const updatePaymentPreferences = async (data: PaymentPreferencesUpdate): Promise<PaymentPreferences> => {
    //TODO: Remove this once the API is updated to support addressType
    data.paymentAccounts.forEach((account) => {
        account.addressType = '3';
    });
    if (data.reimbursementAccount) {
        data.reimbursementAccount.addressType = '3';
    }

    // Include Duo credentials from store if available
    const duoAuthStore = useDuoAuthStore();
    if (duoAuthStore.duoCode && duoAuthStore.state) {
        data.duoCode = duoAuthStore.duoCode;
        data.state = duoAuthStore.state;
    }

    const response = await directDepositRepository.paymentPreferences.paymentPreferencesUpdate(data);
    return response.data;
};

// Init API methods
export const getInit = async (): Promise<Init> => {
    const response = await directDepositRepository.init.initList();
    return response.data;
};

// Stripe API methods - using generated API client
export const createStripeSession = async (data: any): Promise<any> => {
    const response = await directDepositRepository.stripe.createSessionCreate(data);
    return response.data;
};

export const retrieveStripeSession = async (data: any): Promise<any> => {
    const response = await directDepositRepository.stripe.retrieveSessionCreate(data);
    return response.data;
};

export const getStripeAccountNumbers = async (data: any): Promise<any> => {
    const response = await directDepositRepository.stripe.accountNumbersCreate(data);
    return response.data;
};

// Bank info API methods
export const getBankInfo = async (routingNumber: string): Promise<BankInfoResponse> => {
    const response = await directDepositRepository.banks.infoDetail(routingNumber);
    return response.data;
};

export const getBankLogo = async (bankName: string): Promise<BankInfoResponse> => {
    const response = await directDepositRepository.banks.logosDetail(bankName);
    return response.data;
};

export default directDepositRepository;
